// extracted by mini-css-extract-plugin
export default {"header":"ProjectsHeader_header__mf9fo","headerLogout":"ProjectsHeader_headerLogout__ix7px"};